import React, { useEffect, useState } from "react";
import { Checkbox, DatePicker, Input, message } from "antd";
import ModalWrapper from "../../../../components/atoms/formFields/wrapperModal/modalWrapper";
import moment from "moment/moment";
import { useDispatch } from "react-redux";
import {
  detailsSaleListThunk,
  updateStockThunk,
} from "../../../../store/thunks/InventoryThunk";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { isNumberOnly } from "../../../../utils/regex";
import { ContentInputField } from "../../../../components/atoms/formFields/inputField/contentInputField";

const UpdateStockModal = ({
  data,
  storeName,
  stockVariantData,
  inventoryValues,
  setInventoryValues,
  storeId,
}) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [stockId, setStockId] = useState();
  const [errors, setErrors] = useState();
  const [variantData, setVariantData] = useState([]);
  const [prebookable, setPrebookable] = useState();
  useEffect(() => {
    if (stockVariantData?.length > 0) {
      const deepClonedData = stockVariantData.map((item) =>
        JSON.parse(JSON.stringify(item)),
      );
      setVariantData(deepClonedData);
    }
  }, [stockVariantData]);

  const updateInventory = (
    variantKey,
    mrp,
    batchNumber,
    hsnCode,
    price,
    stock,
    minimumOrderQuantity,
    expiryDate,
    maxEligibleQuantity,
    isPreBookAble,
    isCancellable,
    preBookAmount,
    startDateForPreBook,
    lastDateForPreBook,
    estimatedDeliveryDate,
    estimatedDeliveryEndDate,
    cancellationDate,
    lastDateForFullPayment,
    cashOnDeliveryStatus,
    autoCancelAble,
  ) => {
    //     if (!expiryDate) {
    //   message.error("Expiry Date is required");
    //   return;
    // }

    dispatch(
      updateStockThunk({
        stockPostRequest: {
          inventoryId: storeId,
          productId: id,
          variantId: variantKey,
          mrp: Number(mrp),
          batchNumber: batchNumber?.toString(),
          hsnCode: hsnCode,
          price: Number(price),
          stock: Number(stock),
          minimumOrderQuantity: Number(minimumOrderQuantity),
          returnStatus: inventoryValues?.returnStatus ? true : false,
          expiryDate: expiryDate || moment().format("YYYY-MM-DDTHH:mm:ss"),
          maxEligibleQuantity: Number(maxEligibleQuantity),
          isPreBookAble,
          isCancellable,
          preBookAmount: preBookAmount ? Number(preBookAmount) : null,
          startDateForPreBook: startDateForPreBook
            ? moment(startDateForPreBook, "YYYY-MM-DD")
                .startOf("day")
                .subtract(5, "hours")
                .subtract(30, "minutes")
                .format("YYYY-MM-DDTHH:mm:ss")
            : null,

          lastDateForPreBook: lastDateForPreBook
            ? moment(lastDateForPreBook, "YYYY-MM-DD")
                .endOf("day")
                .subtract(5, "hours")
                .subtract(30, "minutes")
                .format("YYYY-MM-DDTHH:mm:ss")
            : null,

          estimatedDeliveryDate,
          estimatedDeliveryEndDate,
          cancellationDate,
          lastDateForFullPayment,
          cashOnDeliveryStatus,
          autoCancelAble,
        },
      }),
    )
      .unwrap()
      .then(() => {
        message.success("Inventory Updated Successfully");
        dispatch(
          detailsSaleListThunk({
            inventoryProductId: {
              inventoryId: storeId,
              productId: id,
            },
          }),
        );
        setStockId("");
      })
      .catch((error) => {
        setStockId("");
      });
  };

  return (
    <div>
      <ModalWrapper
        name="Update Stock Details & Price"
        tooltipText={
          "Update product stock, pricing, batch, expiry, delivery, and selling limit details for your store."
        }
        id="InventorymodalScrollable"
        extraClasses="modal-dialog-scrollable modal-xl"
      >
        <div className="align-items-center d-flex float-lg-left w-100 mb-1">
          <span className="font-size-lg font-weight-bolder m-0">
            Store 01 :{" "}
          </span>
          <span className="font-size-md ml-5 text-muted">{storeName}</span>
        </div>
        <div className="align-items-center justify-content-between d-flex w-100 mb-4">
          <div>
            <span className="font-size-lg font-weight-bolder m-0">
              Product Name :
            </span>
            <span className="font-size-md ml-5 text-muted">
              {data?.name?.en} - {data?.productDetails?.brand?.name?.en}
            </span>
          </div>

          {/* <span className="font-size-md ml-5 text-muted">
            Maximum allowed Selling Limit is 10.
          </span> */}

          <div>
            <Checkbox
              onChange={(e) => {
                setInventoryValues({
                  ...inventoryValues,
                  returnStatus: e.target.checked,
                });
              }}
            >
              Returnable Item
            </Checkbox>
          </div>
        </div>

        <div className="table-responsive Inventory-modals">
          <table
            className="table table-bordered text-center m-0"
            border="0"
            cellSpacing="0"
            cellPadding="0"
            width="100%"
          >
            <thead className="text-white bg-gray-700">
              <tr>
                <th nowrap="nowrap">Size/Model No.</th>
                <th nowrap="nowrap"> Product SKU</th>
                <th nowrap="nowrap"> Product MRP</th>
                <th nowrap="nowrap"> Batch Number</th>
                <th nowrap="nowrap"> HSN Code</th>
                <th nowrap="nowrap">Your Price</th>
                <th nowrap="nowrap">Stock Available</th>
                <th nowrap="nowrap">Min Order Quantity</th>
                <th nowrap="nowrap">Lot Expiration Date</th>
                <th nowrap="nowrap">Selling Limit</th>
                <th>Cash On Delivery</th>
                <th>PreBook</th>
                <th>PreBooking Amount</th>
                <th nowrap="nowrap">PreBooking Start Date</th>
                <th nowrap="nowrap">PreBooking Last Date</th>
                <th nowrap="nowrap">Last Date For Full Payment</th>
                <th nowrap="nowrap">AutoCancellable</th>
                <th>Cancellation Available</th>
                <th nowrap="nowrap">Cancellation Date</th>

                <th nowrap="nowrap">Estimated Stock Availability Date</th>
                <th nowrap="nowrap">Estimated Delivery End Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {variantData?.map((variant, i) => {
                console.log("variant", variant);
                return (
                  <tr key={i.toString()}>
                    <td className="align-middle">
                      <Input disabled value={variant?.variantSize} />
                    </td>
                    <td
                      className="align-middle font-weight-bold"
                      nowrap="nowrap"
                    >
                      <Input disabled value={variant?.sku} />
                    </td>
                    <td className="align-middle font-weight-bold">
                      <ContentInputField
                        disabled={variant?.variantKey !== stockId}
                        errors={
                          variant?.variantKey === stockId ? errors?.mrp : ""
                        }
                        value={variant?.mrp}
                        onChange={(e) => {
                          setInventoryValues({
                            ...inventoryValues,
                            mrp: parseInt(e.target.value),
                          });
                          const temp = [...variantData];
                          temp[i].mrp = e.target.value;
                          setVariantData(temp);
                          setErrors({
                            ...errors,
                            mrp: e.target.value
                              ? isNumberOnly(e.target.value)
                                ? ""
                                : "Invalid MRP"
                              : "MRP is Mandatory",
                          });
                        }}
                      />
                    </td>
                    <td className="align-middle font-weight-bold">
                      <ContentInputField
                        disabled={variant?.variantKey !== stockId}
                        errors={
                          variant?.variantKey === stockId
                            ? errors?.batchNumber
                            : ""
                        }
                        value={variant?.batchNumber}
                        onChange={(e) => {
                          setInventoryValues({
                            ...inventoryValues,
                            batchNumber: e.target.value,
                          });
                          const temp = [...variantData];
                          temp[i].batchNumber = e.target.value;
                          setVariantData(temp);
                          setErrors({
                            ...errors,
                            batchNumber: e.target.value
                              ? isNumberOnly(e.target.value)
                                ? ""
                                : "Invalid Batch Number"
                              : "",
                          });
                        }}
                      />
                    </td>
                    <td className="align-middle font-weight-bold">
                      <ContentInputField
                        disabled={variant?.variantKey !== stockId}
                        errors={
                          variant?.variantKey === stockId ? errors?.hsnCode : ""
                        }
                        value={variant?.hsnCode}
                        style={{ width: "120px" }}
                        maxLength={30}
                        onChange={(e) => {
                          setInventoryValues({
                            ...inventoryValues,
                            hsnCode: e.target.value,
                          });
                          const temp = [...variantData];
                          temp[i].hsnCode = e.target.value;
                          setVariantData(temp);
                          setErrors({
                            ...errors,
                            hsnCode: !e.target.value?.trim()
                              ? "HSN Code is Mandatory"
                              : isNumberOnly(e.target.value)
                                ? ""
                                : "Invalid HSN Code",
                          });
                        }}
                      />
                    </td>
                    <td className="align-middle font-weight-bold">
                      <ContentInputField
                        disabled={variant?.variantKey !== stockId}
                        errors={
                          variant?.variantKey === stockId ? errors?.price : ""
                        }
                        value={variant?.price}
                        onChange={(e) => {
                          setInventoryValues({
                            ...inventoryValues,
                            price: parseInt(e.target.value),
                          });
                          const temp = [...variantData];
                          temp[i].price = e.target.value;
                          setVariantData(temp);
                          setErrors({
                            ...errors,
                            price: e.target.value
                              ? isNumberOnly(e.target.value)
                                ? ""
                                : "Invalid Price"
                              : "Price is Mandatory",
                          });
                        }}
                      />
                    </td>
                    <td className="align-middle font-weight-bold">
                      <ContentInputField
                        disabled={variant?.variantKey !== stockId}
                        errors={
                          variant?.variantKey === stockId ? errors?.stock : ""
                        }
                        onChange={(e) => {
                          setInventoryValues({
                            ...inventoryValues,
                            stock: e.target.value,
                          });
                          const temp = [...variantData];
                          temp[i].stock = e.target.value;
                          setVariantData(temp);
                          setErrors({
                            ...errors,
                            stock: e.target.value
                              ? isNumberOnly(e.target.value)
                                ? ""
                                : "Invalid Stock"
                              : "Stock is Mandatory",
                          });
                        }}
                        value={variant?.stock}
                      />
                    </td>
                    <td className="align-middle font-weight-bold">
                      <ContentInputField
                        disabled={variant?.variantKey !== stockId}
                        errors={
                          variant?.variantKey === stockId
                            ? errors?.minimumOrderQuantity
                            : ""
                        }
                        onChange={(e) => {
                          setInventoryValues({
                            ...inventoryValues,
                            minimumOrderQuantity: e.target.value,
                          });
                          const temp = [...variantData];
                          temp[i].minimumOrderQuantity = e.target.value;
                          setVariantData(temp);
                          setErrors({
                            ...errors,
                            minimumOrderQuantity: e.target.value
                              ? isNumberOnly(e.target.value)
                                ? ""
                                : "Invalid Minimum Order Quantity"
                              : "",
                          });
                        }}
                        value={variant?.minimumOrderQuantity}
                      />
                    </td>
                    <td className="align-middle font-weight-bold">
                      <DatePicker
                        getPopupContainer={() =>
                          document.getElementById("InventorymodalScrollable") ||
                          document.body
                        }
                        className={
                          variant?.variantKey === stockId && errors?.expiryDate
                            ? "invalid"
                            : "renewInputs"
                        }
                        value={
                          variant?.lotExpirationDate
                            ? dayjs(
                                variant?.lotExpirationDate,
                                "YYYY-MM-DDTHH:mm",
                              )
                            : ""
                        }
                        disabled={variant?.variantKey !== stockId}
                        showTime
                        // format={"YYYY-MM-DDTHH:mm:ss"}
                        onChange={(value, dateString) => {
                          const temp = [...variantData];

                          if (value) {
                            const formattedDate =
                              moment(dateString).format("YYYY-MM-DDTHH:mm");

                            setInventoryValues({
                              ...inventoryValues,
                              expiryDate: formattedDate,
                            });

                            temp[i].lotExpirationDate = formattedDate;
                            setVariantData(temp);

                            setErrors({
                              ...errors,
                              expiryDate: "",
                            });
                          } else {
                            setInventoryValues({
                              ...inventoryValues,
                              expiryDate: "",
                            });

                            temp[i].lotExpirationDate = "";
                            setVariantData(temp);

                            setErrors({
                              ...errors,
                              expiryDate: "Expiry Date is Mandatory",
                            });
                          }
                        }}
                      />
                      <small className="text-danger text-capitalize">
                        {errors?.expiryDate}
                      </small>
                    </td>
                    <td className="align-middle font-weight-bold">
                      <ContentInputField
                        disabled={variant?.variantKey !== stockId}
                        max={10}
                        type="number"
                        onChange={(e) => {
                          setInventoryValues({
                            ...inventoryValues,
                            maxEligibleQuantity: e.target.value,
                          });
                          const temp = [...variantData];
                          temp[i].sellingLimit = e.target.value;
                          setVariantData(temp);
                          setErrors({
                            ...errors,
                            maxEligibleQuantity: e.target.value
                              ? ""
                              : "Selling Limit is Mandatory",
                          });
                        }}
                        value={variant?.sellingLimit}
                        errors={
                          variant?.variantKey === stockId
                            ? errors?.maxEligibleQuantity
                            : ""
                        }
                      />
                    </td>
                    <td className="align-middle font-weight-bold">
                      <Checkbox
                        disabled={
                          variant?.variantKey !== stockId ||
                          variant?.isPreBookAble ||
                          inventoryValues.isPreBookAble
                        }
                        checked={variant?.cashOnDeliveryStatus}
                        onChange={(e) => {
                          if (
                            e.target.checked ||
                            variant?.cashOnDeliveryStatus
                          ) {
                            setInventoryValues({
                              ...inventoryValues,
                              cashOnDeliveryStatus: e.target.checked,
                              isPreBookAble: false,
                              isCancellable: false,
                              preBookAmount: "",
                              autoCancelAble: false,
                              lastDateForFullPayment: "",
                              lastDateForPreBook: "",
                              startDateForPreBook: "",
                              cancellationDate: "",
                              estimatedDeliveryDate: "",
                              estimatedDeliveryEndDate: "",
                            });
                          }

                          const temp = [...variantData];
                          temp[i].cashOnDeliveryStatus = e.target.checked;
                          temp[i].isPreBookAble = false;
                          temp[i].isCancellable = false;
                          temp[i].autoCancelAble = false;
                          temp[i].preBookAmount = "";
                          temp[i].lastDateForFullPayment = "";
                          temp[i].lastDateForPreBook = "";
                          temp[i].startDateForPreBook = "";
                          temp[i].cancellationDate = "";
                          temp[i].estimatedDeliveryDate = "";
                          temp[i].estimatedDeliveryEndDate = "";
                          setVariantData(temp);
                        }}
                      />
                    </td>
                    <td className="align-middle font-weight-bold">
                      <Checkbox
                        disabled={
                          (!variant?.isPreBookAble &&
                            (!!inventoryValues?.cancellationDate ||
                              !!inventoryValues?.lastDateForFullPayment) &&
                            moment().format("YYYY-MM-DD") <=
                              moment(inventoryValues?.cancellationDate).format(
                                "YYYY-MM-DD",
                              ) &&
                            moment().format("YYYY-MM-DD") <=
                              moment(
                                inventoryValues?.lastDateForFullPayment,
                              ).format("YYYY-MM-DD")) ||
                          variant?.variantKey !== stockId
                        }
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          if (isChecked) {
                            setInventoryValues({
                              ...inventoryValues,
                              isPreBookAble: e.target.checked,
                              cashOnDeliveryStatus: false,
                            });

                            const temp = [...variantData];
                            temp[i].isPreBookAble = e.target.checked;
                            temp[i].cashOnDeliveryStatus = false;
                            setVariantData(temp);
                          } else {
                            setInventoryValues({
                              ...inventoryValues,
                              isPreBookAble: e.target.checked,
                              isCancellable: false,
                              preBookAmount: "",
                              autoCancelAble: false,
                              lastDateForFullPayment: "",
                              lastDateForPreBook: "",
                              startDateForPreBook: "",
                              cancellationDate: "",
                              estimatedDeliveryDate: "",
                              estimatedDeliveryEndDate: "",
                            });
                            const temp = [...variantData];
                            temp[i].isPreBookAble = e.target.checked;
                            temp[i].isCancellable = false;
                            temp[i].autoCancelAble = false;
                            temp[i].cashOnDeliveryStatus = false;
                            temp[i].preBookAmount = "";
                            temp[i].lastDateForFullPayment = "";
                            temp[i].lastDateForPreBook = "";
                            temp[i].startDateForPreBook = "";
                            temp[i].cancellationDate = "";
                            temp[i].estimatedDeliveryDate = "";
                            temp[i].estimatedDeliveryEndDate = "";
                            setVariantData(temp);
                          }
                        }}
                        checked={variant?.isPreBookAble}
                      />
                    </td>

                    <td className="align-middle font-weight-bold">
                      <Input
                        disabled={variant?.variantKey !== stockId}
                        type="number"
                        className={
                          variant?.variantKey === stockId &&
                          errors?.preBookAmount
                            ? "invalid"
                            : "renewInputs"
                        }
                        onChange={(e) => {
                          setInventoryValues({
                            ...inventoryValues,
                            preBookAmount: e.target.value,
                          });
                          const temp = [...variantData];
                          temp[i].preBookAmount = e.target.value;
                          setVariantData(temp);
                          setErrors({
                            ...errors,
                            preBookAmount: e.target.value
                              ? ""
                              : "Pre-Book Amount is Mandatory",
                          });
                        }}
                        value={variant?.preBookAmount}
                      />
                    </td>

                    <td className="align-middle font-weight-bold">
                      <DatePicker
                        disabled={variant?.variantKey !== stockId}
                        getPopupContainer={() =>
                          document.getElementById("InventorymodalScrollable") ||
                          document.body
                        }
                        disabledDate={(current) =>
                          moment().add(-1, "days") >= current
                        }
                        className={
                          variant?.variantKey === stockId &&
                          errors?.startDateForPreBook
                            ? "invalid"
                            : "renewInputs"
                        }
                        onChange={(value) => {
                          const formattedDate = value?.$d
                            ? moment(value.$d).format("YYYY-MM-DD")
                            : "";

                          // Create updated inventory state with cleared dates
                          const updatedInventory = {
                            ...inventoryValues,
                            startDateForPreBook: formattedDate,
                          };

                          // Update variant data
                          const updatedVariants = [...variantData];
                          updatedVariants[i] = {
                            ...updatedVariants[i],
                            startDateForPreBook: formattedDate,
                          };

                          // Set states
                          setInventoryValues(updatedInventory);
                          setVariantData(updatedVariants);
                          setErrors({
                            ...errors,
                            startDateForPreBook: formattedDate
                              ? ""
                              : "Pre-Book start date is Mandatory",
                          });
                        }}
                        value={
                          variant?.startDateForPreBook
                            ? dayjs(
                                moment
                                  .utc(variant.startDateForPreBook)
                                  .local()
                                  .format("YYYY-MM-DD"),
                                "YYYY-MM-DD",
                              )
                            : null
                        }
                      />
                    </td>

                    <td className="align-middle font-weight-bold">
                      <DatePicker
                        disabled={variant?.variantKey !== stockId}
                        getPopupContainer={() =>
                          document.getElementById("InventorymodalScrollable") ||
                          document.body
                        }
                        disabledDate={(currentDate) => {
                          return (
                            currentDate &&
                            currentDate <=
                              moment(inventoryValues?.startDateForPreBook)
                          );
                        }}
                        className={
                          variant?.variantKey === stockId &&
                          errors?.lastDateForPreBook
                            ? "invalid"
                            : "renewInputs"
                        }
                        onChange={(value) => {
                          const formattedDate = value?.$d
                            ? moment(value.$d).format("YYYY-MM-DD")
                            : "";

                          // Create updated inventory state with cleared dates
                          const updatedInventory = {
                            ...inventoryValues,
                            lastDateForPreBook: formattedDate,
                            lastDateForFullPayment: "",
                            cancellationDate: "",
                            estimatedDeliveryDate: "",
                            estimatedDeliveryEndDate: "",
                          };

                          // Update variant data
                          const updatedVariants = [...variantData];
                          updatedVariants[i] = {
                            ...updatedVariants[i],
                            lastDateForPreBook: formattedDate,
                            lastDateForFullPayment: "",
                            cancellationDate: "",
                            estimatedDeliveryDate: "",
                            estimatedDeliveryEndDate: "",
                          };

                          // Set states
                          setInventoryValues(updatedInventory);
                          setVariantData(updatedVariants);
                          setErrors({
                            ...errors,
                            lastDateForPreBook: formattedDate
                              ? ""
                              : "Pre-Book date is Mandatory",
                          });
                        }}
                        value={
                          variant?.lastDateForPreBook
                            ? dayjs(
                                moment
                                  .utc(variant.lastDateForPreBook)
                                  .local()
                                  .format("YYYY-MM-DD"),
                                "YYYY-MM-DD",
                              )
                            : null
                        }
                      />
                    </td>

                    <td className="align-middle font-weight-bold">
                      <DatePicker
                        allowClear={false}
                        getPopupContainer={() =>
                          document.getElementById("InventorymodalScrollable") ||
                          document.body
                        }
                        disabled={
                          variant?.variantKey !== stockId
                          // ||
                          // !variant?.isPreBookAble
                        }
                        disabledDate={(currentDate) => {
                          return (
                            (currentDate &&
                              currentDate <=
                                moment(
                                  inventoryValues?.lastDateForFullPayment,
                                )) ||
                            currentDate <=
                              moment(inventoryValues?.lastDateForPreBook)
                          );
                        }}
                        value={
                          variant?.lastDateForFullPayment
                            ? dayjs(
                                variant?.lastDateForFullPayment,
                                "YYYY-MM-DD",
                              )
                            : null
                        }
                        className={
                          variant?.variantKey === stockId &&
                          errors?.lastDateForFullPayment
                            ? "invalid"
                            : "renewInputs"
                        }
                        onChange={(value) => {
                          if (value) {
                            setInventoryValues({
                              ...inventoryValues,
                              lastDateForFullPayment: value?.["$d"]
                                ? moment(value?.$d).format(
                                    "YYYY-MM-DDT18:29:59",
                                  )
                                : "",
                            });
                            const temp = [...variantData];
                            temp[i].lastDateForFullPayment = moment(
                              value?.["$d"],
                            ).format("YYYY-MM-DDT18:29:59");
                            setVariantData(temp);
                          } else {
                            setInventoryValues({
                              ...inventoryValues,
                              lastDateForFullPayment: "",
                            });
                            const temp = [...variantData];
                            temp[i].lastDateForFullPayment = "";
                            setVariantData(temp);
                            setErrors({
                              ...errors,
                              lastDateForFullPayment: value?.["$d"]
                                ? ""
                                : "Last Full Payment date is Mandatory",
                            });
                          }
                        }}
                      />
                    </td>

                    <td className="align-middle font-weight-bold">
                      <Checkbox
                        disabled={
                          variant?.variantKey !== stockId
                          // ||
                          // !variant?.isPreBookAble ||
                          // prebookable
                        }
                        onChange={(e) => {
                          setInventoryValues({
                            ...inventoryValues,
                            autoCancelAble: e.target.checked,
                          });
                          const temp = [...variantData];
                          temp[i].autoCancelAble = e.target.checked;
                          setVariantData(temp);
                        }}
                        checked={variant?.autoCancelAble}
                      />
                    </td>
                    <td className="align-middle font-weight-bold">
                      <Checkbox
                        disabled={
                          variant?.variantKey !== stockId
                          // ||
                          // !variant?.isPreBookAble ||
                          // prebookable
                        }
                        onChange={(e) => {
                          setInventoryValues({
                            ...inventoryValues,
                            isCancellable: e.target.checked,
                            cancellationDate: e.target.checked
                              ? inventoryValues?.cancellationDate
                              : false,
                          });
                          const temp = [...variantData];
                          temp[i].isCancellable = e.target.checked;
                          temp[i].cancellationDate = e.target.checked
                            ? inventoryValues?.cancellationDate
                            : null;
                          setVariantData(temp);
                        }}
                        checked={variant?.isCancellable}
                      />
                    </td>

                    <td className="align-middle font-weight-bold">
                      <DatePicker
                        getPopupContainer={() =>
                          document.getElementById("InventorymodalScrollable") ||
                          document.body
                        }
                        className={
                          variant?.variantKey === stockId &&
                          errors?.cancellationDate
                            ? "invalid"
                            : "renewInputs"
                        }
                        disabled={
                          variant?.variantKey !== stockId
                          // ||
                          // !variant?.isCancellable ||
                          // prebookable
                        }
                        disabledDate={(currentDate) => {
                          return (
                            currentDate &&
                            currentDate <=
                              moment(inventoryValues?.lastDateForPreBook)
                          );
                        }}
                        onChange={(value) => {
                          if (value) {
                            setInventoryValues({
                              ...inventoryValues,
                              cancellationDate: value?.["$d"]
                                ? moment(value?.["$d"]).format(
                                    "YYYY-MM-DDThh:mm:ss",
                                  )
                                : "",
                            });
                            const temp = [...variantData];
                            temp[i].cancellationDate = value?.["$d"]
                              ? moment(value?.["$d"]).format(
                                  "YYYY-MM-DDThh:mm:ss",
                                )
                              : "";
                            setVariantData(temp);
                            setErrors({});
                          } else {
                            setInventoryValues({
                              ...inventoryValues,
                              cancellationDate: "",
                            });
                            const temp = [...variantData];
                            temp[i].cancellationDate = "";
                            setVariantData(temp);
                            setErrors({
                              ...errors,
                              cancellationDate: value?.["$d"]
                                ? ""
                                : "Cancellation date is Mandatory",
                            });
                          }
                        }}
                        value={
                          variant?.cancellationDate
                            ? dayjs(variant?.cancellationDate, "YYYY-MM-DD")
                            : null
                        }
                      />
                    </td>

                    <td className="align-middle font-weight-bold">
                      <DatePicker
                        getPopupContainer={() =>
                          document.getElementById("InventorymodalScrollable") ||
                          document.body
                        }
                        className={
                          variant?.variantKey === stockId &&
                          errors?.estimatedDeliveryDate
                            ? "invalid"
                            : "renewInputs"
                        }
                        disabled={variant?.variantKey !== stockId}
                        disabledDate={(currentDate) => {
                          return (
                            currentDate &&
                            currentDate <=
                              moment(inventoryValues?.lastDateForPreBook)
                          );
                        }}
                        onChange={(value) => {
                          if (value) {
                            const dateObj = value.toDate();

                            const utcDate = moment(dateObj)
                              .utc()
                              .format("YYYY-MM-DDTHH:mm:ss");

                            setInventoryValues({
                              ...inventoryValues,
                              estimatedDeliveryDate: utcDate,
                            });

                            const temp = [...variantData];
                            temp[i].estimatedDeliveryDate = utcDate;
                            setVariantData(temp);

                            setErrors({});
                          } else {
                            setInventoryValues({
                              ...inventoryValues,
                              estimatedDeliveryDate: "",
                            });

                            const temp = [...variantData];
                            temp[i].estimatedDeliveryDate = "";

                            setVariantData(temp);

                            setErrors({
                              ...errors,
                              estimatedDeliveryDate:
                                "Delivery date is Mandatory",
                            });
                          }
                        }}
                        value={
                          variant?.estimatedDeliveryDate
                            ? dayjs.utc(variant.estimatedDeliveryDate).local()
                            : null
                        }
                      />
                    </td>

                    <td className="align-middle font-weight-bold">
                      <DatePicker
                        getPopupContainer={() =>
                          document.getElementById("InventorymodalScrollable") ||
                          document.body
                        }
                        className={
                          variant?.variantKey === stockId &&
                          errors?.estimatedDeliveryEndDate
                            ? "invalid"
                            : "renewInputs"
                        }
                        disabled={
                          variant?.variantKey !== stockId
                          // ||
                          // !variant?.isPreBookAble ||
                          // prebookable
                        }
                        disabledDate={(currentDate) => {
                          return (
                            currentDate &&
                            currentDate <=
                              moment(inventoryValues?.estimatedDeliveryDate)
                          );
                        }}
                        onChange={(value) => {
                          if (value) {
                            const dateObj = value.toDate(); // ✅ safe conversion

                            setInventoryValues({
                              ...inventoryValues,
                              estimatedDeliveryEndDate: dateObj
                                ? moment(dateObj).format("YYYY-MM-DDT18:29:59")
                                : "",
                            });

                            const temp = [...variantData];
                            temp[i].estimatedDeliveryEndDate = dateObj
                              ? moment(dateObj).format("YYYY-MM-DDT18:29:59")
                              : "";
                            setVariantData(temp);

                            setErrors({});
                          } else {
                            setInventoryValues({
                              ...inventoryValues,
                              estimatedDeliveryEndDate: "",
                            });

                            const temp = [...variantData];
                            temp[i].estimatedDeliveryEndDate = "";

                            setErrors({
                              ...errors,
                              estimatedDeliveryEndDate:
                                "Delivery end date is Mandatory",
                            });
                          }
                        }}
                        value={
                          variant?.estimatedDeliveryEndDate
                            ? dayjs(variant?.estimatedDeliveryEndDate)
                            : null
                        }
                      />
                    </td>

                    <td className="align-middle font-weight-bold">
                      <i
                        className="flaticon-edit icon-md text-dark font-weight-bold mr-5 cursor-pointer"
                        onClick={() => {
                          setStockId(variant?.variantKey);
                          setPrebookable(variant?.isPreBookAble);
                          setInventoryValues({
                            ...inventoryValues,
                            mrp: variant?.mrp,
                            batchNumber: variant?.batchNumber,
                            hsnCode: variant?.hsnCode,
                            price: variant?.price,
                            stock: variant?.stock,
                            minimumOrderQuantity: variant?.minimumOrderQuantity
                              ? variant?.minimumOrderQuantity
                              : 1,
                            expiryDate: variant?.lotExpirationDate,
                            maxEligibleQuantity: variant?.sellingLimit
                              ? variant?.sellingLimit
                              : 1,
                            isPreBookAble: variant?.isPreBookAble
                              ? variant?.isPreBookAble
                              : false,
                            isCancellable: variant?.isCancellable
                              ? variant?.isCancellable
                              : false,
                            preBookAmount: variant?.preBookAmount,
                            startDateForPreBook: variant?.startDateForPreBook,
                            lastDateForPreBook: variant?.lastDateForPreBook,
                            estimatedDeliveryDate:
                              variant?.estimatedDeliveryDate,
                            estimatedDeliveryEndDate:
                              variant?.estimatedDeliveryEndDate,
                            cancellationDate: variant?.cancellationDate,
                            lastDateForFullPayment:
                              variant?.lastDateForFullPayment,
                            cashOnDeliveryStatus: variant?.cashOnDeliveryStatus
                              ? variant?.cashOnDeliveryStatus
                              : false,
                            autoCancelAble: variant?.autoCancelAble,
                          });
                        }}
                      ></i>
                      <button
                        type="button"
                        className="all_bottom_buttons px-5 py-2 radius-0"
                        disabled={variant?.variantKey !== stockId}
                        onClick={(e) => {
                          e.preventDefault();

                          if (
                            inventoryValues?.hsnCode &&
                            inventoryValues?.price &&
                            inventoryValues?.stock &&
                            inventoryValues?.maxEligibleQuantity &&
                            inventoryValues?.expiryDate &&
                            inventoryValues?.mrp
                          ) {
                            if (inventoryValues?.isPreBookAble) {
                              if (
                                inventoryValues?.preBookAmount &&
                                inventoryValues?.startDateForPreBook &&
                                inventoryValues?.lastDateForPreBook &&
                                inventoryValues?.lastDateForFullPayment &&
                                inventoryValues?.estimatedDeliveryDate &&
                                inventoryValues?.estimatedDeliveryEndDate &&
                                (inventoryValues?.isCancellable
                                  ? inventoryValues?.cancellationDate &&
                                    inventoryValues?.cancellationDate
                                  : true)
                              ) {
                                if (
                                  parseInt(inventoryValues?.preBookAmount) >
                                  parseInt(inventoryValues?.price)
                                ) {
                                  message.error(
                                    "Pre-booking Amount can not be more than your price",
                                  );
                                } else {
                                  variant?.variantKey === stockId &&
                                    updateInventory(
                                      variant?.variantKey,
                                      inventoryValues?.mrp
                                        ? inventoryValues?.mrp
                                        : "",
                                      inventoryValues?.batchNumber
                                        ? inventoryValues?.batchNumber
                                        : "",
                                      inventoryValues?.hsnCode
                                        ? inventoryValues?.hsnCode
                                        : "",

                                      inventoryValues?.price
                                        ? inventoryValues?.price
                                        : "",
                                      inventoryValues?.stock
                                        ? inventoryValues?.stock
                                        : "",
                                      inventoryValues?.minimumOrderQuantity
                                        ? inventoryValues?.minimumOrderQuantity
                                        : 1,

                                      inventoryValues?.expiryDate
                                        ? inventoryValues?.expiryDate
                                        : null,
                                      inventoryValues?.maxEligibleQuantity
                                        ? inventoryValues?.maxEligibleQuantity
                                        : "",
                                      inventoryValues?.isPreBookAble
                                        ? inventoryValues?.isPreBookAble
                                        : false,
                                      inventoryValues?.isCancellable
                                        ? inventoryValues?.isCancellable
                                        : false,
                                      inventoryValues?.preBookAmount
                                        ? inventoryValues?.preBookAmount
                                        : "",
                                      inventoryValues?.startDateForPreBook
                                        ? inventoryValues?.startDateForPreBook
                                        : null,
                                      inventoryValues?.lastDateForPreBook
                                        ? inventoryValues?.lastDateForPreBook
                                        : null,
                                      inventoryValues?.estimatedDeliveryDate
                                        ? inventoryValues?.estimatedDeliveryDate
                                        : null,
                                      inventoryValues?.estimatedDeliveryEndDate
                                        ? inventoryValues?.estimatedDeliveryEndDate
                                        : null,
                                      inventoryValues?.cancellationDate
                                        ? inventoryValues?.cancellationDate
                                        : null,
                                      inventoryValues?.lastDateForFullPayment
                                        ? inventoryValues?.lastDateForFullPayment
                                        : null,
                                      inventoryValues?.cashOnDeliveryStatus
                                        ? inventoryValues?.cashOnDeliveryStatus
                                        : false,
                                      inventoryValues?.autoCancelAble
                                        ? inventoryValues?.autoCancelAble
                                        : false,
                                    );
                                }
                              } else {
                                // Validations
                                setErrors({
                                  ...errors,
                                  preBookAmount: inventoryValues?.preBookAmount
                                    ? ""
                                    : "Pre Book Amount is Mandatory",
                                  startDateForPreBook:
                                    inventoryValues?.startDateForPreBook
                                      ? ""
                                      : "Start Date For PreBook is Mandatory",
                                  lastDateForPreBook:
                                    inventoryValues?.lastDateForPreBook
                                      ? ""
                                      : "Last Pre Book Date is Mandatory",
                                  lastDateForFullPayment:
                                    inventoryValues?.lastDateForFullPayment
                                      ? ""
                                      : "Full Payment Date is Mandatory",
                                  estimatedDeliveryDate:
                                    inventoryValues?.estimatedDeliveryDate
                                      ? ""
                                      : "Delivery Date is Mandatory",
                                  estimatedDeliveryEndDate:
                                    inventoryValues?.estimatedDeliveryEndDate
                                      ? ""
                                      : "Delivery End Date is Mandatory",
                                  cancellationDate:
                                    inventoryValues?.cancellationDate
                                      ? ""
                                      : "Cancellation Date is Mandatory",
                                });
                              }
                            } else {
                              variant?.variantKey === stockId &&
                                updateInventory(
                                  variant?.variantKey,
                                  inventoryValues?.mrp
                                    ? inventoryValues?.mrp
                                    : "",
                                  inventoryValues?.batchNumber
                                    ? inventoryValues?.batchNumber
                                    : "",
                                  inventoryValues?.hsnCode
                                    ? inventoryValues?.hsnCode
                                    : "",

                                  inventoryValues?.price
                                    ? inventoryValues?.price
                                    : "",
                                  inventoryValues?.stock
                                    ? inventoryValues?.stock
                                    : "",
                                  inventoryValues?.minimumOrderQuantity
                                    ? inventoryValues?.minimumOrderQuantity
                                    : null,
                                  inventoryValues?.expiryDate
                                    ? inventoryValues?.expiryDate
                                    : null,
                                  inventoryValues?.maxEligibleQuantity
                                    ? inventoryValues?.maxEligibleQuantity
                                    : "",
                                  inventoryValues?.isPreBookAble
                                    ? inventoryValues?.isPreBookAble
                                    : false,
                                  inventoryValues?.isCancellable
                                    ? inventoryValues?.isCancellable
                                    : false,
                                  inventoryValues?.preBookAmount
                                    ? inventoryValues?.preBookAmount
                                    : null,
                                  inventoryValues?.startDateForPreBook
                                    ? inventoryValues?.startDateForPreBook
                                    : null,
                                  inventoryValues?.lastDateForPreBook
                                    ? inventoryValues?.lastDateForPreBook
                                    : null,
                                  inventoryValues?.estimatedDeliveryDate
                                    ? inventoryValues?.estimatedDeliveryDate
                                    : null,
                                  inventoryValues?.estimatedDeliveryEndDate
                                    ? inventoryValues?.estimatedDeliveryEndDate
                                    : null,
                                  inventoryValues?.cancellationDate
                                    ? inventoryValues?.cancellationDate
                                    : null,
                                  inventoryValues?.lastDateForFullPayment
                                    ? inventoryValues?.lastDateForFullPayment
                                    : null,
                                  inventoryValues?.cashOnDeliveryStatus
                                    ? inventoryValues?.cashOnDeliveryStatus
                                    : false,
                                  inventoryValues?.autoCancelAble
                                    ? inventoryValues?.autoCancelAble
                                    : false,
                                );
                            }
                          } else {
                            setErrors({
                              ...errors,
                              hsnCode: inventoryValues?.hsnCode
                                ?.toString()
                                ?.trim()
                                ? ""
                                : "HSN Code is Mandatory",
                              stock: inventoryValues?.stock
                                ? ""
                                : "Stock is Mandatory",
                              price: inventoryValues?.price
                                ? ""
                                : "Price is Mandatory",
                              maxEligibleQuantity:
                                inventoryValues?.maxEligibleQuantity
                                  ? ""
                                  : "Max Eligible Quantity is Mandatory",
                              expiryDate: inventoryValues?.expiryDate
                                ? ""
                                : "Expiry Date is Mandatory",
                              mrp: inventoryValues?.mrp
                                ? ""
                                : "Mrp is Mandatory",
                            });
                          }
                        }}
                      >
                        Update
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>{" "}
            *
          </table>
        </div>
      </ModalWrapper>
    </div>
  );
};

export default UpdateStockModal;
